import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { useGoLiveNow } from '../../hooks/broadcast';
import { useTime } from '../../state/timeState';
import { formatDate } from '../../utils/time';
import { Button } from '../Button';
import { Frame } from '../Frame';
import { ClockIcon, OrangePlusIcon } from '../Icon';
import { scheduleBroadcast } from '../popups/ScheduleBroadcastPopup';
export function LobbyFrame() {
    const time = useTime();
    const startBroadcast = useGoLiveNow();
    const formattedTime = time ? formatDate(time, 'H:mm') : undefined;
    const formattedDate = time ? formatDate(time, 'EEEE, d LLLL') : undefined;
    if (!formattedDate || !formattedTime) {
        return null;
    }
    return (_jsx(LobbyFrameRoot, { children: _jsxs(Content, { children: [_jsx(DateDisplay, { children: formattedDate }), _jsx(TimeDisplay, { children: formattedTime }), _jsxs(Buttons, { children: [_jsx(Button, { type: "button", kind: "secondary", size: "big", icon: _jsx(ClockIcon, {}), onClick: () => {
                                scheduleBroadcast();
                            }, children: "Schedule" }), _jsx(Button, { type: "button", size: "big", icon: _jsx(OrangePlusIcon, {}), onClick: () => {
                                startBroadcast({
                                    saveBroadcast: true,
                                });
                            }, children: "Instant Broadcast" })] })] }) }));
}
const DateDisplay = styled.div `
    font-size: clamp(1.25rem, 4.6875vw, 1.5rem);
    font-weight: 500;
    line-height: 1;
    opacity: 0.5;
`;
const TimeDisplay = styled.div `
    font-size: clamp(3.75rem, 15.625vw, 5rem);
    font-weight: 600;
    line-height: 1;
    margin-top: 0.75rem;
`;
const Buttons = styled.div `
    display: grid;
    gap: 1rem;
    grid-template-columns: 1fr;
    margin-top: clamp(2.5rem, 11.71875vw, 3.75rem);
    width: 100%;

    @media (min-width: 32rem) {
        grid-template-columns: 1fr 1fr;
    }
`;
const Content = styled(Frame) `
    color: #ffffff;
    margin: 0 auto;
    min-width: 0;
`;
const LobbyFrameRoot = styled.div `
    box-sizing: border-box;
    margin: 0 auto;
    max-width: 100%;
    padding: 0 1.75rem;
    width: 36rem;
`;
